// src/pages/admin/bracket/BracketComp.jsx
import React, { useRef, useEffect, useState } from "react";
import RoundColumn from "./Round";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import "./bracket.css";

export default function BracketComp({ rounds, onWinnerSelect, onMoveFighter, onAutoAdvance }) {
  const wrapperRef = useRef(null);
  const [matchPositions, setMatchPositions] = useState({}); // { [matchId]: {x, y} }

  // Update match positions for SVG connectors dynamically
  useEffect(() => {
    if (!wrapperRef.current) return;

    const positions = {};
    rounds.forEach((round, rIndex) => {
      const roundEl = wrapperRef.current.children[0]?.children[rIndex]; // bracket-columns > round-column
      if (!roundEl) return;

      Array.from(roundEl.querySelectorAll(".match-card")).forEach((matchEl, mIndex) => {
        const rect = matchEl.getBoundingClientRect();
        const wrapperRect = wrapperRef.current.getBoundingClientRect();

        positions[round.matches[mIndex]?.id] = {
          x: rect.left - wrapperRect.left + rect.width,
          y: rect.top - wrapperRect.top + rect.height / 2,
        };
      });
    });

    setMatchPositions(positions);
  }, [rounds]);

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="bracket-wrapper" ref={wrapperRef}>
        {/* SVG connectors */}
        <svg className="bracket-lines">
          {rounds.map((round, rIndex) => {
            if (rIndex === rounds.length - 1) return null;

            return (round.matches || []).map((match, mIndex) => {
              if (!match) return null;

              const from = matchPositions[match.id];
              const nextMatchIndex = Math.floor(mIndex / 2);
              const nextMatch = rounds[rIndex + 1]?.matches[nextMatchIndex];
              const to = matchPositions[nextMatch?.id];

              if (!from || !to) return null;

              const controlX = (from.x + to.x) / 2; // smooth curve control point

              return (
                <path
                  key={`${match.id}-${rIndex}`}
                  d={`M ${from.x} ${from.y} C ${controlX} ${from.y}, ${controlX} ${to.y}, ${to.x} ${to.y}`}
                  stroke="#9ca3af"
                  strokeWidth="2"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              );
            });
          })}
        </svg>

        {/* Rounds */}
        <div className="bracket-columns">
          {rounds.map((round, idx) => (
            <RoundColumn
              key={idx}
              title={round.title}
              matches={round.matches || []}
              roundIndex={idx}
              onWinnerSelect={onWinnerSelect}
              onMoveFighter={onMoveFighter}
              onAutoAdvance={onAutoAdvance}
            />
          ))}
        </div>
      </div>
    </DndProvider>
  );
}
